'use strict';

(function () {
  'use strict';

  angular.module('vnext').service('inspirationSvc', inspirationSvc);

  inspirationSvc.$inject = ['$translate', 'httpSvc', 'alertSvc', '$log', 'eventTrackingSvc'];

  /* @ngInject */
  function inspirationSvc($translate, httpSvc, alertSvc, $log, eventTrackingSvc) {

    var _inspirationCache = {
      type: '',
      data: [],
      page: 0
    };

    return {
      getType: getType,
      getNextPage: getNextPage,
      clearCache: clearCache,
      get: get,
      findByUser: findByUser,
      create: create,
      update: update,
      delete: del
    };

    ////////////////

    function create(inspiration) {
      if (!inspiration.image) {
        return alertSvc.error($translate.instant('vnext.inspirations.missing'));
      }
      return httpSvc.post('/apiproxy/user/communityinspirations', inspiration).then(function (res) {
        alertSvc.success($translate.instant('vnext.inspirations.created'));
        return res;
      });
    }

    function update(inspiration) {
      return httpSvc.post('/apiproxy/user/communityinspirations/update', inspiration);
    }

    function del(inspiration) {
      return httpSvc.delete('/apiproxy/user/communityinspirations/' + inspiration.id).then(function (res) {
        alertSvc.success($translate.instant('vnext.inspirations.deleted'));
        return res;
      });
    }

    function findByUser(userId) {
      return httpSvc.get('/apiproxy/user/communityinspirations/byuser/' + userId);
    }

    function get(url) {
      return httpSvc.get('/apiproxy/user/communityinspirations/' + url);
    }

    function getType(suffix, limit, page) {
      var limitQuery = !angular.isUndefined(limit) && !angular.isUndefined(page) ? '?limit=' + limit + '&page=' + page : '';
      return httpSvc.get('/apiproxy/user/communityinspirations/' + suffix + limitQuery);
    }

    function clearCache(newType) {
      _inspirationCache.type = newType || '';
      _inspirationCache.data = [];
      _inspirationCache.page = 0;
    }

    // Remove all the properties that are not used for rendering an inspiration in the list view.
    function _mapForListView(inspArray) {
      return _.map(inspArray, function (insp) {
        return {
          id: insp.id,
          createdOn: insp.createdOn,
          title: insp.title,
          description: insp.description,
          url: insp.url,
          userId: insp.userId,
          userAlias: insp.userAlias,
          favorites: insp.favorites,
          imagePreview: insp.imagePreview,
          image: insp.image
        };
      });
    }

    function getNextPage(type, pageSize, isReturnLastFoundPage) {
      $log.debug('Inspiration page size: ', pageSize);

      // Clear the cache if this is a new type of inspiration.
      if (_inspirationCache.type !== type) {
        clearCache(type);
      }

      eventTrackingSvc.fireEvent('community', 'loadInspPage', undefined, _inspirationCache.page);

      return getType(type, pageSize, _inspirationCache.page).then(function (newInspirations) {
        // If the latest response is the same as the last response,
        // there are no more inspirations left.
        if (_inspirationCache.data === newInspirations || newInspirations && newInspirations.length === 0) {
          if (isReturnLastFoundPage) {
            return _mapForListView(_inspirationCache.data);
          }
          return false;
        }

        // Save this response to the _inspirationCache to compare against next time.
        _inspirationCache.data = newInspirations;
        _inspirationCache.page++;

        return _mapForListView(newInspirations);
      });
    }
  }
})();